import type { IconSvgObject } from './types';

const DropletsIcon: IconSvgObject = [
  ["path", { d: "M12.5 4.7217C11.3718 3.37372 10.5 2.50195 10.5 2.50195C10.5 2.50195 3.5 9.50195 3.5 14.502C3.5 18.3679 6.63401 21.502 10.5 21.502C12.731 21.502 14.7182 20.4583 16 18.8326", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 15.502C18.933 15.502 20.5 13.8525 20.5 11.8177C20.5 9.18616 17 5.50195 17 5.50195C17 5.50195 13.5 9.18616 13.5 11.8177C13.5 13.8525 15.067 15.502 17 15.502Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10.5 17.502C8.84315 17.502 7.5 16.1588 7.5 14.502", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DropletsIcon;
